/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PublicAccess } from '../models/public-access';

@Injectable({
  providedIn: 'root',
})
export class PublicAccessService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPublicAccessForDocumentUpload
   */
  static readonly GetPublicAccessForDocumentUploadPath = '/api/v1/PublicAccess/Documents/Upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicAccessForDocumentUpload$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentUpload$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PublicAccess>> {

    const rb = new RequestBuilder(this.rootUrl, PublicAccessService.GetPublicAccessForDocumentUploadPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PublicAccess>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicAccessForDocumentUpload$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentUpload$Plain(params?: {
  },
  context?: HttpContext

): Observable<PublicAccess> {

    return this.getPublicAccessForDocumentUpload$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<PublicAccess>) => r.body as PublicAccess)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicAccessForDocumentUpload$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentUpload$Json$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PublicAccess>> {

    const rb = new RequestBuilder(this.rootUrl, PublicAccessService.GetPublicAccessForDocumentUploadPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PublicAccess>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicAccessForDocumentUpload$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentUpload$Json(params?: {
  },
  context?: HttpContext

): Observable<PublicAccess> {

    return this.getPublicAccessForDocumentUpload$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<PublicAccess>) => r.body as PublicAccess)
    );
  }

  /**
   * Path part for operation getPublicAccessForDocumentDownload
   */
  static readonly GetPublicAccessForDocumentDownloadPath = '/api/v1/PublicAccess/Documents/Download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicAccessForDocumentDownload$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentDownload$Plain$Response(params?: {
    storageFileName?: string;
    originalFileName?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PublicAccess>> {

    const rb = new RequestBuilder(this.rootUrl, PublicAccessService.GetPublicAccessForDocumentDownloadPath, 'post');
    if (params) {
      rb.query('storageFileName', params.storageFileName, {});
      rb.query('originalFileName', params.originalFileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PublicAccess>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicAccessForDocumentDownload$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentDownload$Plain(params?: {
    storageFileName?: string;
    originalFileName?: string;
  },
  context?: HttpContext

): Observable<PublicAccess> {

    return this.getPublicAccessForDocumentDownload$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<PublicAccess>) => r.body as PublicAccess)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicAccessForDocumentDownload$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentDownload$Json$Response(params?: {
    storageFileName?: string;
    originalFileName?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PublicAccess>> {

    const rb = new RequestBuilder(this.rootUrl, PublicAccessService.GetPublicAccessForDocumentDownloadPath, 'post');
    if (params) {
      rb.query('storageFileName', params.storageFileName, {});
      rb.query('originalFileName', params.originalFileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PublicAccess>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicAccessForDocumentDownload$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentDownload$Json(params?: {
    storageFileName?: string;
    originalFileName?: string;
  },
  context?: HttpContext

): Observable<PublicAccess> {

    return this.getPublicAccessForDocumentDownload$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<PublicAccess>) => r.body as PublicAccess)
    );
  }

  /**
   * Path part for operation getPublicAccessForDocumentOpen
   */
  static readonly GetPublicAccessForDocumentOpenPath = '/api/v1/PublicAccess/Documents/Open';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicAccessForDocumentOpen$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentOpen$Plain$Response(params?: {
    storageFileName?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PublicAccess>> {

    const rb = new RequestBuilder(this.rootUrl, PublicAccessService.GetPublicAccessForDocumentOpenPath, 'post');
    if (params) {
      rb.query('storageFileName', params.storageFileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PublicAccess>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicAccessForDocumentOpen$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentOpen$Plain(params?: {
    storageFileName?: string;
  },
  context?: HttpContext

): Observable<PublicAccess> {

    return this.getPublicAccessForDocumentOpen$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<PublicAccess>) => r.body as PublicAccess)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicAccessForDocumentOpen$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentOpen$Json$Response(params?: {
    storageFileName?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PublicAccess>> {

    const rb = new RequestBuilder(this.rootUrl, PublicAccessService.GetPublicAccessForDocumentOpenPath, 'post');
    if (params) {
      rb.query('storageFileName', params.storageFileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PublicAccess>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicAccessForDocumentOpen$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicAccessForDocumentOpen$Json(params?: {
    storageFileName?: string;
  },
  context?: HttpContext

): Observable<PublicAccess> {

    return this.getPublicAccessForDocumentOpen$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<PublicAccess>) => r.body as PublicAccess)
    );
  }

}
